import { render, staticRenderFns } from "./PalletLabelLink.vue?vue&type=template&id=96a8223a&"
import script from "./PalletLabelLink.vue?vue&type=script&lang=js&"
export * from "./PalletLabelLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports